const t = {
  BOLT: "bolt",
  PLENTY: "plenty"
};
export {
  t as THEMES
};
